<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">I dedicate this book to my husband, best friend, and soulmate, my Papa Bear. To my children, Jessica and Missy who are my first and loudest cheerleaders. To family and friends, who are my most incredible supporters. To Naleighna Kai and the NK Tribe Called Success for taking me under your wing and teaching this bird to soar. To Stephanie M. Freeman, my “drink and two-step” partner in crime. To my editor, who takes the broken pieces of my words ensuring they are woven together in such a fashion, they create a beautiful tapestry. To the beta readers who dedicate countless hours to be the first set of eyes to partake of the deliciousness of this story. And to you, the reader, for your encouragement and support of the beautiful gift of writing given to me from God.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?028cb7d8